import actions from './actions';

const initState = {
  errorMessage: null,
  isError: false,
  auditLogs: null,
  auditLogsLoading: false,
  auditLogsHasMore: false,
  auditLogsPagination: null,
  auditLogsLoadMore: false
};

export default function reducer(state = initState, action) {
  switch (action.type) {
    case actions.FETCHING_AUDIT_LOGS:
      return {
        ...state,
        auditLogsLoading: true,
        isError: false,
        auditLogsLoadMore: action.load_more
      };

    case actions.FETCH_AUDIT_LOGS_SUCCESS:
      const newLogs = !!action?.load_more
        ? [...(state?.logs ?? []), ...(action?.result ?? [])]
        : action?.result;

      return {
        ...state,
        auditLogs: newLogs,
        auditLogsLoading: false,
        errorMessage: action.message,
        isError: false,
        auditLogsPagination: action.pagination
      };

    case actions.FETCH_AUDIT_LOGS_FAILED:
      return {
        ...state,
        auditLogsLoading: false,
        errorMessage: action.message,
        isError: true,
        auditLogsPagination: action.pagination
      };

    default:
      return state;
  }
}
